import React from 'react';
import { Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

interface Testimonial {
  name: string;
  role: string;
  company: string;
  content: string;
  image: string;
}

function TestimonialCard({ testimonial }: { testimonial: Testimonial }) {
  return (
    <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={20} className="fill-yellow-400 text-yellow-400" />
        ))}
      </div>
      <p className="text-gray-600 mb-6 italic">"{testimonial.content}"</p>
      <div className="flex items-center gap-4">
        <img 
          src={testimonial.image} 
          alt={testimonial.name}
          className="w-12 h-12 rounded-full object-cover"
        />
        <div>
          <h4 className="font-semibold text-[#0D3C4C]">{testimonial.name}</h4>
          <p className="text-sm text-gray-500">{testimonial.role}, {testimonial.company}</p>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const { t } = useLanguage();
  
  const testimonialImages = [
    "https://img.freepik.com/free-photo/fashionable-woman-brown-coat-beige-hat-posing_273443-3773.jpg?t=st=1738765462~exp=1738769062~hmac=373cf3670178fc0e4fbb3001079f0aa252a7b83d11711130193d2e92222fa351&w=1480",
    "https://img.freepik.com/free-photo/african-american-man-wearing-round-glasses_273609-10062.jpg?t=st=1738764907~exp=1738768507~hmac=a9677f50cdac6923db291f323c458fc4fac818975fad8000352e53ceaf691db3&w=1480",
    "https://img.freepik.com/free-photo/happy-beautiful-smiling-waitress-wearing-apron-holding-folder-menu-restaurant-looking-camera-standing-cozy-coffeehouse-good-service_657921-502.jpg?t=st=1738765201~exp=1738768801~hmac=6359b3b99da410639eb98f56b213993d6b098426eff7843b94592d18ef45ce8c&w=1480",
  ];

  const testimonials = t.testimonials.cards.map((card, index) => ({
    ...card,
    image: testimonialImages[index]
  }));

  return (
    <section id="testimonials" className="py-32 bg-slate-100">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-20">
          <h3 className="text-4xl font-bold text-[#0D3C4C] mb-6">
            {t.testimonials.title}
          </h3>
          <p className="text-xl text-gray-600">
            {t.testimonials.subtitle}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
}
